export default {"src":"/_next/static/media/fun.fbec6644.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};